const SCROLL_TO_TOP_MESSAGE = {
    source: 'authenticating',
    version: 1,
    type: 'uiEvent',
    data: { action: 'scrollToTop' },
};

/** Scrolls the app to the top and, when it runs inside an iframe, asks the embedding page to do the same. */
export const scrollToTop = () => {
    window.scrollTo(0, 0);

    if (window.parent !== window) {
        window.parent.postMessage(SCROLL_TO_TOP_MESSAGE, '*');
    }
};
